import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.string.link.js";
import Error from "@/views/error/error.vue";
import HoldingOrderSummary from "@/components/order/HoldingOrderSummary.vue";
import ConsultantOrderSummary from "@/components/order/ConsultantOrderSummary.vue";
import ConsultantOrdersSubMenusLinks from "@/components/menu/sub-menus/orders/ConsultantOrdersSubMenuLinks.vue";
import { request } from "@/js/http/http_request";
import { isConsultantOrHolding, isConsultantNotHolding, isHolding, isUserBuyerGroup } from "@/js/http/auth";
export default {
  name: "ConsultantOrderView",
  props: ["loggedUserData"],
  data: function data() {
    return {
      id_order: null,
      order: null,
      isDataLoading: true,
      error: {
        title: "order not found",
        link: "",
        linkTitle: "to orders",
        params: {
          tab: "orders"
        }
      }
    };
  },
  created: function created() {
    this.id_order = this.$route.params.id;
    this.error.link = isUserBuyerGroup(this.loggedUserData) ? "userOrderList" : "adminOrderList";
    this.getOrder();
  },
  components: {
    HoldingOrderSummary: HoldingOrderSummary,
    ConsultantOrderSummary: ConsultantOrderSummary,
    ConsultantOrdersSubMenusLinks: ConsultantOrdersSubMenusLinks,
    Error: Error
  },
  methods: {
    getOrder: function getOrder() {
      var _this = this;
      this.$EventBus.$emit("loading", true);
      request("/v1/order/" + _this.id_order, "get", null, true, "api").then(function (response) {
        _this.order = _objectSpread({}, response.data);
        _this.isDataLoading = false;
        if (isConsultantNotHolding(_this.loggedUserData) && _this.loggedUserData.idUser == _this.order.id_user) {
          _this.$router.push({
            name: "userOrderSummary",
            params: {
              id: _this.id_order
            }
          });
        }
      }).catch(function (_) {
        _this.isDataLoading = false;
      });
    },
    isConsultantOrHolding: isConsultantOrHolding,
    isHolding: isHolding
  }
};